<template>
  <div class="account-page" :class="{ active: active }" :data-account-page="id">
    <div class="inner">
         <div class="heading-custom">
      <h4 class="font-md wt-md">
        Thanks for taking the next step
      </h4>
      <!-- <span
        class="tags tags-desktop"
        v-if="!$store.getters['user/stripeConnectIsOnboarded']"
      >
        <span class="alert-tag error"
          >Please complete your payment details</span
        >
      </span> -->
      </div>

      <div class="intro lh-tight" style="margin-bottom: 30px">
        <p>
          You can now take control organizing and controlling your listings,
          giving you the whole picture.
        </p>
      </div>
      

      <div class="form-group vanilla submit">
        <div class="multi-action">
          <div class="form-action align-center">
            <button
              type="button"
              class="button green"
              @click="navigateOverview"
            >
              <svg-icon id="dashboard"></svg-icon>
              <span>Take me to my dashboard</span>
            </button>
          </div>
          <div class="form-action align-center">
            <button
              type="button"
              class="button tertiary"
              @click="createListing"
            >
              <svg-icon id="binoculars"></svg-icon>
              <span>Create a listing</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.inner -->
  </div>
  <!-- /.account-page.profile-details -->
</template>

<script>
import AccountSubpage from "../../../AccountSubpage";

export default {
  extends: AccountSubpage,

  data() {
    return {
      id: "profile-complete",
      loading: false,
    };
  },

  methods: {
    createListing() {
      this.$store.dispatch("modals/showAddListing");
    },

    navigateOverview() {
      this.$store.commit("account/navigateTo", {
        pane: "overview",
        page: "overview",
      });
    },
  },
};
</script>
